

interface IOptions {
  label: string;
  value: string;
}

export const GenderList: Array<IOptions> = [
  {
    label: 'Male',
    value: '1'
  },
  {
    label: 'Female',
    value: '2',
  },
];